<template>
    <div>
        <b-row>
            <b-col>
                <app-form-select label="Fecha" v-model="reportDate" :options="reportDates" value-field="value" text-field="text"> </app-form-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" class="d-flex flex-column align-items-center">
                <div>Asistentes</div>
                <div class="bg-info indicator text-white">
                    <h3>{{ assistantsInEvent.length }}</h3>
                </div>
            </b-col>
            <b-col cols="6" class="d-flex flex-column align-items-center">
                <div>Faltantes</div>
                <div class="bg-warning indicator text-white">
                    <h3>{{ assistantsNotInEvent.length }}</h3>
                </div>
            </b-col>
        </b-row>
        <b-row align-h="center" class="d-flex flex-column align-items-center">
            <b-col cols="auto">
                <div>Participación</div>
                <div class="bg-success indicator text-white text-center">
                    <h3>{{ assistantPercent | decimal(0) }}%</h3>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-5" align-h="center">
            <b-col cols="12" lg="10">
                <app-btn-excel @click="downloadAssistantsReport">Descargar listado de ingresos</app-btn-excel>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        assistants: [],
        reportDate: '',
        reportDates: [],
    }),
    watch: {
        reportDate(val) {
            this.loadAssitants()
        },
    },
    computed: {
        assistantsInEvent() {
            return this.assistants.filter((item) => !!item.event_invitation_entries_count)
        },
        assistantsNotInEvent() {
            return this.assistants.filter((item) => !item.event_invitation_entries_count)
        },
        assistantPercent() {
            return this.assistants.length === 0 ? 0 : (this.assistantsInEvent.length / this.assistants.length) * 100
        },
    },
    methods: {
        listen() {
            Echo.private(`event-${this.event.id}`).listen('.EntryRegistered', ({ assistant }) => {
                const assistants = this.assistants.filter((item) => item.id !== assistant.id)
                assistants.push(assistant)
                this.assistants = assistants
            })
        },
        async loadAssitants() {
            const { data: assistants } = await this.$repo.get(`events/${this.event.id}/assistants`, { date: this.reportDate })
            this.assistants = assistants
        },
        downloadAssistantsReport() {
            window.open(`/web/v1/events/${this.event.id}/download-assistants-report`, '_blank')
        },
    },
    created() {
        this.reportDate = moment(this.event.event_date).format('YYYY-MM-DD')
        let startDate = moment(this.event.event_date).startOf('day')
        const endDate = moment(this.event.end_date).startOf('day')
        const dates = []
        let day = 1
        while (startDate <= endDate) {
            dates.push({ text: `Día ${day} (${startDate.format('DD/MM/YYYY')})`, value: startDate.format('YYYY-MM-DD') })
            startDate = moment(startDate).add(1, 'days')
            day++
        }
        this.reportDates = dates
    },
    mounted() {
        this.loadAssitants()
        this.listen()
    },
    beforeDestroy() {
        Echo.leave(`event-${this.event.id}`)
    },
}
</script>

<style scoped>
.indicator {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
}
</style>
